<div class="full-width text-left">
    <h3 class="mat-display-1">Trust icons</h3>
  </div>
<wz-trust-icon-form></wz-trust-icon-form>
